import React from 'react'

export function Avatar({
  user,
}: {
  user: {
    first_name?: string
    last_name?: string
    username?: string
  }
}) {
  const { first_name, last_name, username } = user
  const initials = first_name?.[0] + last_name?.[0] ?? username?.[0]
  const displayName = first_name && last_name ? `${first_name} ${last_name}` : username

  return (
    <div className='flex gap-1 items-center'>
      <div className='avatar placeholder'>
        <div className='bg-black text-base-100 w-6 rounded-full'>
          <span className='text-xs uppercase font-semibold'>{initials}</span>
        </div>
      </div>
      <div className='text-sm font-semibold'>{displayName}</div>
    </div>
  )
}
